import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import { CFCProps } from 'types';
import {
  ExpandableTile,
  TileAboveTheFoldContent,
  TileBelowTheFoldContent
} from 'carbon-components-react';
import {
  ArrowRight16,
  Location16,
  EventSchedule16,
  Construction16
} from '@carbon/icons-react';
import {
  formFullAddress,
  toLocalDateTimeFormat,
  toLocalDateFormat
} from 'utilities/helper.util';
import { SCREEN_SIZE } from 'types';
import MapView from '../MapView';

export const SmallScreen: React.FC<Props> = ({ enquiryData, screenSize }) => {
  const [showMap, setShowMap] = useState<boolean>(true);

  const handleHideShowMap = () => {
    setShowMap(!showMap);
  };

  const shouldHideShowMap = (evt: any) => {
    if (mapContainerRef.current && evt.target) {
      return !mapContainerRef.current.contains(evt.target);
    }

    return true;
  };

  const isSMScreen = screenSize === SCREEN_SIZE.SM;

  const mapContainerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div className="smaller-screen">
      <div className="enquiry-info-section">
        <div className="enquiry-title">{enquiryData.user_reference}</div>
        <div className="enquiry-info-content">
          <div className="info-row">
            <div className="info-title">
              {!isSMScreen ? 'Job site' : <Location16 />}
            </div>
            &nbsp;
            <div className="info-value">
              {formFullAddress(enquiryData.address)}
            </div>
          </div>
          <div className="info-row">
            <div className="info-title">
              {!isSMScreen ? 'Enquiry date' : <EventSchedule16 />}
            </div>
            &nbsp;
            <div className="info-value">
              {toLocalDateTimeFormat(enquiryData.enquiry_at)}
            </div>
          </div>
          <div className="info-row">
            <div className="info-title">
              {!isSMScreen ? 'Job dates' : <Construction16 />}
            </div>
            &nbsp;
            <div className="info-value">
              {toLocalDateFormat(enquiryData.start_at)}
              &nbsp;
              <ArrowRight16 />
              &nbsp;
              {toLocalDateFormat(enquiryData.end_at)}
            </div>
          </div>
        </div>
      </div>
      <div className="enquiry-map">
        <ExpandableTile
          expanded={showMap}
          handleClick={handleHideShowMap}
          onBeforeClick={shouldHideShowMap}
          className="enquiry-map-expandable-tile"
        >
          <TileAboveTheFoldContent>
            {!showMap && <div className="enquiry-map-title">Show map</div>}
          </TileAboveTheFoldContent>
          <TileBelowTheFoldContent>
            <MapView
              divRef={mapContainerRef}
              shape={enquiryData.shape}
              status={enquiryData.status}
              isExpired={enquiryData.is_expired}
            />
          </TileBelowTheFoldContent>
        </ExpandableTile>
      </div>
    </div>
  );
};

SmallScreen.displayName = 'SmallScreen';

const connector = connect();

type OwnProps = {
  enquiryData: any;
  screenSize: any;
};

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(SmallScreen));
